<script>

import {discountServiceList, getAvailableServiceList, getSubscription, getUserServiceList} from "@/api/subscriptions";

import * as organizationApi from '@/api/organizations';
import {mapActions, mapGetters} from "vuex";
import moment from "moment";

export default {
  name: 'SubscriptionSettingsDetailsPage',
  components: {},
  data() {

    this.setStep(1)

    let services = []

    let service_id = 0

    let selected_services = []

    let discounts = []

    let active_services = []
    getUserServiceList().then(
        (response) => {
          this.active_services = [...response.data.active_services, ...response.data.awaiting_services]
        }
    )

    discountServiceList().then(
        (json) => {
          this.discounts = json.data.data.periods
          this.setDiscounts(json.data.data.periods)
        }
    )

    getAvailableServiceList().then(
        (json) => {
          this.services = json.data.data.services
        }
    )

    return {


      service: {},

      service_id: service_id,

      current: {
        unit_count: 0,
        service: {
          name: ''
        },
        slots: []
      },

      services: services,
      selected_services: selected_services,
      durations: [],
      organizations: [],
      query: '',
      discounts: discounts,
      active_services: active_services
    }
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters('subscription', [
      'isChecked',
      'isModalVisible',
      'getBusySlots',
      'getSlots',
      'getItemSlots',
      'isSlotPresented',
      'getStep',
      'getItems',
      'getState',
      'getServices',
      'getItemSlotsList',
      'getDiscount',


      'getSettingsSlots',
      'getSettingsPeriod',
      'getSettingsItems',
      'getSettingsDiscount',
      'getSettingsItemSlots',
    ]),
    ...mapGetters('user', ['USER_ID']),
    ...mapGetters('workspace', ['ID_WORK_SPACE']),
    serviceNum() {
      return this.services.filter(service => this.isChecked(service.id)).length;
    },
    getSum() {
      return this.getPeriodEndDate(this.current) * this.current.service.price_per_unit * this.getNewSettingsSlotItems()
          + this.getSettingsPeriod() * this.service.price_per_unit * (this.getNewSettingsSlotItems() + this.current.slots.length) * (100 - this.getSettingsDiscount()) / 100
    },
    // getNewSettingsSlotItems() {
    //   return this.getSettingsSlots() > 0 ? Math.max(this.getSettingsSlots() - (this.current.unit_count - this.current.slots.length), 0) : 0
    // },
    totalSlotsCount() {
      return this.getNewSettingsSlotItems() + this.current.unit_count
    }
  },
  methods: {
    ...mapActions('subscription', ['setSlots', 'hideModal', 'showModal', 'toggleItemSlot', 'setDiscounts', 'setStep', 'toggleService']),
    async load() {

      this.service_id = this.$route.params.id
      let response = await organizationApi.workspaceOrganizations(this.ID_WORK_SPACE);
      this.organizations = response.data.data.map(
          (item) => {
            return {
              id: item.id,
              name: item.short_name,
              inn: item.inn
            }
          }
      )

      getSubscription(this.$route.params.id).then(
          (response) => {
            this.current = response.data
            this.service = response.data.service
          }
      )
    },
    getFinishDate(service) {
      return moment(service.subscription_finish_date, 'YYYY-MM-DD').format('D.MM.Y')
    },
    getNewFinishDate(service) {
      const duration = this.getSettingsPeriod()
      return moment(service.subscription_finish_date, 'YYYY-MM-DD').add(duration, 'M').format('D.MM.Y')
    },
    getStartDate(id) {
      return this.getServiceStartDate(id).format('D.MM.Y')
    },
    getPeriodEndDate(service) {

      const end = moment(service.subscription_finish_date, 'YYYY-MM-DD')
      const now = moment()

      return Math.max(end.diff(now, 'month'), 1)
    },
    now() {
      return moment().format('D.MM.Y')
    },
    getServiceStartDate(id) {
      const index = this.active_services.map(param => param.service_id).lastIndexOf(id)
      if (this.active_services[index]) {
        if (moment(this.active_services[index].subscription_finish_date) > moment()) {
          return moment(this.active_services[index].subscription_finish_date, 'YYYY-MM-DD')
        }
      }
      return moment()
    },
    getNewSettingsSlotItems() {
      return this.getSettingsSlots() - this.current.unit_count
    },
  }
}
</script>

<template>
  <div class="ais24--subscription">
    <div class="ais24--container">
      <div class="ais24--steps">
        <ul class="ais24--steps__list">
          <li class="ais24--steps__item" :class="getStep() === 0 ? ' active': ''">Подписка на сервисы</li>
          <li class="ais24--steps__item" :class="getStep() === 1 ? ' active': ''">Детали подписки</li>
          <li class="ais24--steps__item" :class="getStep() === 2 ? ' active': ''">Оплата</li>
        </ul>
      </div>
      <header class="ais24--header">
        <h2 class="ais24--title">Детали подписки</h2>
      </header><!--/.ais24--header-->
      <div class="ais24--details" v-if="current.id">
        <div class="ais24--details__content">
          <div class="ais24--selected-subscriptions">

            <div class="ais24--selected-subscriptions-card">
              <div class="ais24--selected-subscriptions-card__headline">
                <h4 class="ais24--selected-subscriptions-card__title">Сервис &laquo;{{
                    current.service.name
                  }}&raquo;</h4>
                <div class="ais24--selected-subscriptions-card__actions">
                  <!--                  <button class="ais24&#45;&#45;button" type="button">-->
                  <!--                                            <span class="ais24&#45;&#45;button__icon">-->
                  <!--                                                <svg class="ais24&#45;&#45;icon ais24&#45;&#45;icon&#45;&#45;18x18">-->
                  <!--                                                    <use xlink:href="/img/sprite.svg#icon-18-trash"></use>-->
                  <!--                                                </svg>-->
                  <!--                                            </span>-->
                  <!--                    <span class="ais24&#45;&#45;button__text" @click="toggleService(service)">Удалить</span>-->
                  <!--                  </button>-->
                </div>
              </div>

              <ul class="ais24--selected-subscriptions-card__list">
                <li class="ais24--selected-subscriptions-card__item" v-if="getSettingsPeriod() > 0">
                  <div class="ais24--selected-subscriptions-card__caption">Добавленный период подписки</div>
                  <div class="ais24--selected-subscriptions-card__info">
                    <p>Новый период подписки: до {{ getNewFinishDate(current) }}</p>
                    <p>Текущий период подписки: до {{ getFinishDate(current) }}</p>
                  </div>
                  <div class="ais24--selected-subscriptions-card__value">+ {{ getSettingsPeriod() }} месяца</div>
                </li>
                <li class="ais24--selected-subscriptions-card__item" v-if="getNewSettingsSlotItems() > 0">
                  <div class="ais24--selected-subscriptions-card__caption">Мест организаций</div>
                  <div class="ais24--selected-subscriptions-card__info">
                    <p>Новое количество мест: {{ getNewSettingsSlotItems() + current.slots.length }} мест</p>
                    <p>Текущее количество мест: {{ current.unit_count }} мест</p>
                  </div>
                  <div class="ais24--selected-subscriptions-card__value">+ {{ getNewSettingsSlotItems() }} место</div>
                </li>
              </ul>

            </div>

          </div><!--/.ais24--selected-subscriptions-->
        </div><!--/.ais24--details__content-->
        <aside class="ais24--details__sidebar">
          <div class="ais24--calculation">
            <header class="ais24--calculation-header">
              <h3 class="ais24--calculation-header__title">Расчет стоимости:</h3>
            </header><!--/.ais24--calculation-header-->
            <div class="ais24--calculation-body">
              <div class="ais24--calculation-card">
                <div class="ais24--calculation-card__caption">Сервис</div>
                <ul class="ais24--calculation-card__list">
                  <li class="ais24--calculation-card__item">
                    <strong class="ais24--calculation-card__title">{{ service.name }}</strong>
                    <span class="ais24--calculation-card__info">{{ service.price_per_unit }} ₽/мес. за 1 место</span>
                  </li>
                  <template v-if="getNewSettingsSlotItems() > 0">
                    <li class="ais24--calculation-card__item">
                      <strong class="ais24--calculation-card__title">Оставшийся период текущей подписки:</strong>
                      <span class="ais24--calculation-card__info">{{ getPeriodEndDate(current) }} мес.
                      (с {{ now() }} до {{ getFinishDate(current) }})</span>
                    </li>
                  </template>
                  <li class="ais24--calculation-card__item" v-if="getNewSettingsSlotItems() > 0">
                    <strong class="ais24--calculation-card__title">+{{ getNewSettingsSlotItems() }} места организации:</strong>
                    <span class="ais24--calculation-card__info">
                      {{ service.price_per_unit }} ₽ &times; {{
                        getPeriodEndDate(current)
                      }} мес. &times; {{ getNewSettingsSlotItems() }} слот. =
                                                <strong>{{
                                                    getPeriodEndDate(current) * service.price_per_unit * getNewSettingsSlotItems()
                                                  }} ₽</strong>
                                            </span>
                  </li>
                </ul>
                <ul class="ais24--calculation-card__list" v-if="getSettingsPeriod() > 0">
                  <li class="ais24--calculation-card__item">
                    <strong class="ais24--calculation-card__title">Новый период подписки:</strong>
                    <span class="ais24--calculation-card__info">{{
                        getSettingsPeriod()
                      }} мес. (с {{ getFinishDate(current) }} до {{ getNewFinishDate(current) }})</span>
                  </li>
                  <li class="ais24--calculation-card__item">
                    <strong class="ais24--calculation-card__title">{{ totalSlotsCount }} мест
                      организации:</strong>
                    <span class="ais24--calculation-card__info">{{
                        service.price_per_unit
                      }} ₽ &times; {{ getSettingsPeriod() }} мес. &times; {{
                        totalSlotsCount
                      }} слот =

                      <template v-if="getSettingsDiscount() > 0">
                      <s>{{
                          getSettingsPeriod() * service.price_per_unit * (getNewSettingsSlotItems() + current.slots.length)
                        }} ₽</s>
                                                <strong>{{
                                                    getSettingsPeriod() * service.price_per_unit * (getNewSettingsSlotItems() + current.slots.length) * (100 - getSettingsDiscount()) / 100
                                                  }} ₽</strong>
                        </template>
                        <template v-else>
                          <strong>{{
                              getSettingsPeriod() * service.price_per_unit * (getSettingsSlots() + current.slots.length)
                            }} ₽</strong>
                        </template>
                                            </span>
                    <span class="ais24--calculation-card__discount"
                          v-if="getSettingsDiscount()">{{ getSettingsDiscount() }}% скидка</span>
                  </li>
                </ul>
              </div><!--/.ais24--calculation-card-->
            </div><!--/.ais24--calculation-body-->
            <footer class="ais24--calculation-footer">
              <div class="ais24--calculation-total">
                <div class="ais24--calculation-total__text">Итого к оплате:</div>
                <div class="ais24--calculation-total__price">{{
                    getSum
                  }}&nbsp;₽
                </div>
              </div><!--/.ais24--calculation-total-->
            </footer><!--/.ais24--calculation-footer-->
          </div><!--/.ais24--calculation-->
        </aside><!--/.ais24--details__sidebar-->
      </div>
    </div>
    <div class="ais24--actions-bar" v-if="current.id">
      <div class="ais24--container">
        <div class="ais24--actions-bar-holder">
          <div class="ais24--actions-bar-holder__previous">
            <router-link class="ais24--button ais24--button--outline ais24--button--large"
                         :to="{name: 'SubscriptionSettingsPage', params: {id: service_id}}">
              <span class="ais24--button__text">Назад</span>
            </router-link>
          </div>
          <div class="ais24--actions-bar-holder__status">Итого к оплате
            <mark>{{ getSum }} рублей</mark>
          </div>
          <div class="ais24--actions-bar-holder__next">
            <router-link class="ais24--button ais24--button--primary ais24--button--large"
                         :to="{name: 'SubscriptionSettingsPayPage', params: {id: service_id}}">
              <span class="ais24--button__text">Продолжить</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<style scoped lang="scss">
.ais24--dialog .ais24--dialog-body {
  flex: auto;
}
</style>
